import {
  blockingPromotionIssues,
  isPromotionPrerequisitesError,
  overridableFundStatusIssues,
  structuredApiErrorMessage,
} from '../investorPromotionPrerequisites';
import { promotionIssueDisplayText } from '../FundOpportunityAdmin/promotionPrerequisiteMessages';
import type { PromotionPrerequisiteIssue } from '../../../services/BaseBackendService';

export interface PrerequisiteHandlerCallbacks {
  onError: (message: string) => void;
  onWarning?: (message: string) => void;
  openPrerequisiteModal: (options: {
    issues: PromotionPrerequisiteIssue[];
    retry: () => Promise<void>;
    onSuccess: () => void;
  }) => void;
}

export function runInvestorOperationWithPrerequisites(
  run: (options: { overrideFundStatusRestriction?: boolean }) => Promise<void>,
  successCallback: () => void,
  operationName: string,
  callbacks: PrerequisiteHandlerCallbacks,
): void {
  run({})
    .then((response: unknown) => {
      if (
        typeof response === 'object' &&
        response !== null &&
        (response as { adminWarning?: { requiresConfirmation?: boolean; message?: string } })
          .adminWarning?.requiresConfirmation
      ) {
        const warning = (response as { adminWarning: { message?: string } }).adminWarning;
        callbacks.onWarning?.(
          `${operationName} requires confirmation: ${warning.message}. Please use the Fund Opportunity Admin page for detailed operations on managed funds.`,
        );
        return;
      }
      successCallback();
    })
    .catch((err: unknown) => {
      if (isPromotionPrerequisitesError(err)) {
        const blocking = blockingPromotionIssues(err.issues);
        if (blocking.length > 0) {
          callbacks.onError(blocking.map((issue) => promotionIssueDisplayText(issue)).join(' '));
          return;
        }
        const overridable = overridableFundStatusIssues(err.issues);
        if (overridable.length > 0) {
          callbacks.openPrerequisiteModal({
            issues: overridable,
            retry: () => run({ overrideFundStatusRestriction: true }),
            onSuccess: successCallback,
          });
          return;
        }
      }
      console.error(`Error in ${operationName}:`, err);
      callbacks.onError(`${operationName}: ${structuredApiErrorMessage(err)}`);
    });
}
